<script setup lang="ts">
const theme = usePaginationTheme();
const paginationContext = usePaginationContext();

const selectedSize = computed<number>({
  get: () => paginationContext.currentPageSize.value ?? paginationContext.pageSizeOptions.value[0],
  set: (val: number) => paginationContext.setPageSize(val)
});

watch(selectedSize, (newSize) => {
  paginationContext.setPageSize(newSize);
});
</script>
<template>
  <label :class="theme.pageSize.selectLabel()">
    {{ $t('Pagination.Aria.ItemsPerPage', { itemType: paginationContext.itemTypePlural.value }) }}:
    <select
      v-model.number="selectedSize"
      :class="theme.pageSize.select()"
      name="page-size-select"
    >
      <option
        v-for="(size, index) in paginationContext.pageSizeOptions.value"
        :key="`${size}-${index}`"
        :disabled="size === paginationContext.currentPageSize.value"
        :value="size"
      >
        {{ size }}
      </option>
    </select>
  </label>
</template>
